// extracted by mini-css-extract-plugin
export var optionGrid = "_5k-7";
export var optionList = "_5k-6";
export var questionsBlock = "_5k-9";
export var spacer = "_5k-5";
export var stepCenteredContent = "_5k-3";
export var stepInner = "_5k-0";
export var stepInnerFullWidth = "_5k-1";
export var stepInnerLockScroll = "_5k-2";
export var stepTransitionFrame = "_5k-4";
export var welcomeBlock = "_5k-8";